import { hasInjectionContext } from 'vue'
import { useRoute } from 'vue-router'
import { logger } from '@gsretail/gssm-util'
import { urlDecHelper } from './helper/url.helper'

const LOG_LEVEL = 'debug'
const LOGGER_GLOBAL_VAR_NAME = 'gsconsole'

export function getLogger() {
  if (!hasInjectionContext()) {
    return logger
  }
  const route = useRoute()
  if (route === undefined) {
    return logger
  }
  const path = urlDecHelper(route.path)
  return logger.getLogger(path)
}

export function initLogger() {
  setAllLogLevel(LOG_LEVEL)
  setLoggerGlobalVariable()
}

function setAllLogLevel(level) {
  logger.setLevel(level)
  Object.values(logger.getLoggers()).forEach((l) => l.setLevel(level))
}

function setLoggerGlobalVariable() {
  Object.defineProperty(globalThis, LOGGER_GLOBAL_VAR_NAME, {
    get: () => getLogger()
  })
}
